const schema = [
        ['month'],
        ['hours'],
        ['project'],
        ['user'],
];

export default schema;
